/**
 * Enum dùng công thức
 */
export default {
  Use: 1,
  None: 0,
};
